import { render, staticRenderFns } from "./Limit.vue?vue&type=template&id=3fccaabb&"
import script from "./Limit.vue?vue&type=script&lang=js&"
export * from "./Limit.vue?vue&type=script&lang=js&"
import style0 from "./Limit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports